import { totalDistanceGainLossFormatter } from "../../formatters";
import { agingMarginEnable, isComboPON, isGPON, isXGSPON } from "../../tools";

export const CalculatorCommonMethods = (id: string) => {
    const methods: {[key: string]: any} = {
        "xgs_pon_tx_comb_trans": {
            isVisible: () => {
                return isComboPON()
            }
        },
        "gpon_tx_comb_trans": {
            isVisible: () => {
                return isComboPON()
            }
        },
        "xgs_pon_tx_xgs_trans": {
            isVisible: () => {
                return isXGSPON();
            }
        },
        "gpon_tx_gpon_trans": {
            isVisible: () => {
                return isGPON();
            }
        },
        "aging_margin": {
            isVisible: () => {
                return agingMarginEnable();
            }
        },
    }
    return methods[id]
}
export const CalculatorMethods = (id: string) => {
    const methods: {[key: string]: any} = {
        "transceiver_1": {
            isVisible: () => {
                return true;
            }
        },
        "xgs_pon_tx_comb_trans": {
            isVisible: () => {
                return isComboPON()
            }
        },
        "gpon_tx_comb_trans": {
            isVisible: () => {
                return isComboPON()
            }
        },
        "xgs_pon_tx_xgs_trans": {
            isVisible: () => {
                return isXGSPON();
            }
        },
        "gpon_tx_gpon_trans": {
            isVisible: () => {
                return isGPON();
            }
        },
        "splitter_1": {
            isVisible: () => {
                return true;
            }
        },
        "splitter_2": {
            isVisible: () => {
                return true;
            }
        },
        "splitter_3": {
            isVisible: () => {
                return true;
            }
        },
        "splice_qty": {
            isVisible: () => {
                return true;
            }
        },
        "aging_margin": {
            isVisible: () => {
                return agingMarginEnable();
            }
        },
        "connectors": {
            isVisible: () => {
                return true;
            }
        },
        "measurement_error": {
            isVisible: () => {
                return true;
            }
        },
        "total_distance": {
            isVisible: () => {
                return true;
            }
        },
        "margin_requirement": {
            isVisible: () => {
                return true;
            }
        },
    }
    return methods[id]
}

export const CalculatorGainLossMethods = (id: string) => {
    const methods: {[key: string]: any} = {
        "transceiver_1": {
            isVisible: () => {
                return true;
            }
        },
        "xgs_pon_tx_comb_trans": {
            isVisible: () => {
                return isComboPON()
            }
        },
        "gpon_tx_comb_trans": {
            isVisible: () => {
                return isComboPON()
            }
        },
        "xgs_pon_tx_xgs_trans": {
            isVisible: () => {
                return isXGSPON();
            }
        },
        "gpon_tx_gpon_trans": {
            isVisible: () => {
                return isGPON();
            }
        },
        "splitter_1": {
            isVisible: () => {
                return true;
            }
        },
        "splitter_2": {
            isVisible: () => {
                return true;
            }
        },
        "splitter_3": {
            isVisible: () => {
                return true;
            }
        },
        "splice_qty": {
            isVisible: () => {
                return true;
            }
        },
        "aging_margin": {
            isVisible: () => {
                return agingMarginEnable();
            }
        },
        "connectors": {
            isVisible: () => {
                return true;
            }
        },
        "measurement_error": {
            isVisible: () => {
                return true;
            }
        },
        "total_distance": {
            prepareData: (component: any, allState: any) => {
                if(component[component.valueID]) {
                   
                    component[component.valueID] = totalDistanceGainLossFormatter(component)
                }
                
                return component;
            },
            isVisible: () => {
                return true;
            }
        },
        "margin_requirement": {
            isVisible: () => {
                return false;
            }
        },
    }
    return methods[id]
}

export const CalculatorAdditionalSettingsMethods = (id: string) => {
    const methods: {[key: string]: any} = {
        "total_distance": {
            isVisible: () => {
                return true;
            }
        }
    }
    return methods[id]
}